import {isLegacyItem}   from "@Common/logic/item/is-legacy-item";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {CcApis3}        from "@Common/tools/cc-integration/cc_apis/cc-apis-3";
import {equalDeep}      from "@Common/utils/objects";

import {Updater} from "./updater";

export const PersistStep = ({sku, status, prepareSave, next: rootNext}) => cs(
    consumeContext("apis"),
    consumeContext("systemConstants"),
    consumeContext("userLevels"),
    ["updater", ({apis}, next) => Updater({sku, apis, prepareSave, next})],
    ({updater, systemConstants, userLevels}) => rootNext(async (prepare) => {
        if (prepare.type === "createNew") {

            status.preparing();

            const newItem = await updater.createCcItem({
                listingUniqueId: prepare.listingUniqueId,
                listSelected: userLevels.listSelected,
                listExternalId: userLevels.listExternalId,
            });

            return {newItem,type:prepare.type};

        } else { // update

            status.updating();
            //need variations to not trigger state deletion since it only needs to update style selection/assignment.
            let x = {...prepare.oldItem?.sku};
            delete x.variation;
            let y = {...sku};
            delete y.variation;
            if( prepare.oldItem?.proofEngineType === 0 && prepare.oldItem?.metaData?.ccReference
                && (!equalDeep(x, y)) ) {
                prepare.oldItem.metaData.oldCcReference = prepare.oldItem.metaData.ccReference;
                delete prepare.oldItem.metaData.ccReference;
            }

            if ( isLegacyItem(prepare.oldItem)) {

                const newItem = await updater.updateLegacyItem({oldItem: prepare.oldItem});

                return {newItem,type:prepare.type};
            } else {

                const newItem = await updater.updateCcItem({oldItem: prepare.oldItem});

                return {newItem,type:prepare.type};
            }
        }
    }),
);